let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aRyFL")).then(() => parcelRequire('5SAHQ'));